import exercisesApi from 'api/rest/exercises/exercises';
import { resolveSubjectNumericId } from 'services/common/subjectParsers/subjectParsers';
import logError from 'utils/logError/logError';
import asyncDebounce from 'utils/asyncDebounce/asyncDebounce';

import useSubjectStore from '../subject';

const onlyIfUndefined = (value, fallback) => (value === undefined ? fallback : value);

const allExercisesCheck = value => (value === 'all' ? null : value);

const parseArrayLike = value => (value?.length ? value : null);

const parseVariables = (base, overrides = {}) => {
  const { subject } = useSubjectStore.getState();
  const subjectId = resolveSubjectNumericId(overrides?.subject ?? subject);
  const { section, userMarks, subsection, orderBy, filters, curriculum, isDone } = base;

  return {
    subject: subjectId,
    section: allExercisesCheck(onlyIfUndefined(overrides.section, section)),
    subsection: allExercisesCheck(onlyIfUndefined(overrides.subsection, subsection)),
    marks: parseArrayLike(onlyIfUndefined(overrides.userMarks, userMarks)),
    isDone: parseArrayLike(onlyIfUndefined(overrides.isDone, isDone)),
    orderBy: onlyIfUndefined(overrides.orderBy, orderBy),
    tags: parseArrayLike(onlyIfUndefined(overrides.filters, filters)),
    curriculum: parseArrayLike(onlyIfUndefined(overrides.curriculum, curriculum)),
    offset: overrides.offset || 0,
  };
};

const getExercises = asyncDebounce(async rawVariables => {
  const { subject, ...rest } = rawVariables;
  if (!subject) {
    return {};
  }

  try {
    const page = await exercisesApi.getList({
      ...rest,
      subject,
      limit: 50,
    })();
    return {
      allExercisesCompleted: false,
      exercises: page.exercises.map(({ id }) => ({ id })),
      exercisesCount: page.count,
      fetched: true,
    };
  } catch (error) {
    sessionStorage.removeItem(`${import.meta.env.VITE_VERSION}_exercises`);
    window.location.href = '/';
    logError(error);
    return {};
  }
}, 500);

export { parseVariables };
export default getExercises;
